<template>
  <div
    id="designField"
    v-on:mousemove="moveCom()"
    v-bind:style="{ width: cWidth + 'px', height: cHeight + 'px' }"
  >
    <canvas
      id="canvas"
      :width="cWidth"
      :height="cHeight"
      v-bind:style="{ width: cWidth + 'px', height: cHeight + 'px' }"
      v-on="{ mousedown: drawIn, mouseup: drawOut }"
      v-on:mousemove="drawing()"
      v-on:click="searchLine()"
    >
    </canvas>
    <div
      v-for="com in comList"
      v-bind:key="com.comNum"
      :class="com.class"
      v-bind:style="com.style"
    >
      <div
        class="cripForCom"
        :data-comNum="com.comNum"
        v-on="{ mousedown: moveComStart, mouseup: moveComEnd }"
      ></div>
      <ComConstruct
        :com="com"
        :comNum="com.comNum"
        ref="comCon"
        :texts="com.texts"
      />
    </div>
  </div>
</template>

<script>
import MousePosi from "./mousePosi.js";
import ComConstruct from "./ComConstruct.vue";
import MakeNode from "./makeNode.js";
import ArrowCam from "./arrowCanvas.js";
import KeySearch from "./keySearch.js";

export default {
  name: "mainCanvas",
  el: "canvas",
  components: { ComConstruct },
  props: {
    mode: { type: String, default: "none" },
    cHeight: { type: Number },
    cWidth: { type: Number },
  },
  data() {
    return {
      comList: [],
      lineList: [],
      model: { position: "absolute" },
      nowGripedNode: {}, //Com動かす用
      histTmp: null, //古いComを保管してundoに入れる用
      nowGripedNodeOption: { delNode: function () {} }, //focus中のCom OR lineに対するサブメニューを管理している
      undoStack: [],
      redoStack: [],
    };
  },
  mounted() {
    //取り出す時は複数形refs 属性名はref単数
    //   console.log(this.$refs);
    this.ctx = document.getElementById("canvas").getContext("2d");
    this.isDrawing = false;
    this.isComDrag = false;
    this.pointTmpPosi = { comNum: -1 }; //子要素で使う
    this.AbNode = document.getElementById("designField");
    this.mdP = [0, 0];
    document.onkeydown = (e) => {
      if (e.ctrlKey == true) this.keyJudge(e.which, e);
    };
  },
  watch: {
    nowGripedNode: {
      handler(val, oldVal) {
        const posi = new MousePosi(this.AbNode);
        if (val.type == "drawLine") {
          var list = this.lineList;
          var type = "delLine";
        } else {
          //type==com
          var list = this.comList;
          var type = "delCom";
        }
        const index = list.indexOf(val);
        this.nowGripedNodeOption.delNode();
        this.nowGripedNodeOption = new MakeNode(
          "designField",
          "delete",
          posi,
          list,
          index,
          this.undoStack,
          type,
          this.drawLines
        );
        this.drawLines();
        // console.log(this.nowGripedNodeOption);
      },
      deep: false,
    },
  },
  methods: {
    drawIn: function () {
      const posi = new MousePosi(this.AbNode);
      var col = "#000";
      switch (this.mode) {
        case "class":
          col = "#ff6";
          break;
        case "func":
          col = "#f66";
          break;
        default:
          return;
      }
      if (this.mode == "class" || this.mode == "func") {
        this.ctx.fillStyle = col;
        this.mdP = posi;
      }
      this.isDrawing = true;
    },
    drawing: function () {
      if (this.isDrawing == false) return;
      const posi = new MousePosi(this.AbNode);
      if (this.isDrawing == true) {
        switch (this.mode) {
          case "class":
          case "func":
            this.ctx.fillRect(
              this.mdP.x,
              this.mdP.y,
              posi.x - this.mdP.x,
              posi.y - this.mdP.y
            );
            //  console.log(this.ctx);
            //        console.log(this.mdP.x, this.mdP.y, posi.x, posi.y);
            break;
        }
      }
    },
    drawOut: function () {
      if (this.isDrawing == false) return;
      const posi = new MousePosi(this.AbNode);
      let enableDraw = false;
      var div = {};
      div.class = this.mode;
      if (this.mode == "class" || this.mode == "func") {
        if (this.comList.length > 0) {
          const L = this.comList[this.comList.length - 1].comNum;
          div.comNum = parseInt(L) + 1;
        } else {
          div.comNum = 0;
        }
        div.type = "com";
        div.isfocus = false;
        div.texts = [
          { text: "", title: "" },
          { text: "", title: "" },
          { text: "", title: "" },
        ];
        div.style = { ...this.model };
        div.style.left = this.mdP.x + "px";
        div.style.top = this.mdP.y + "px";
        div.style.width = posi.x - parseInt(div.style.left) + "px";
        div.style.height = posi.y - parseInt(div.style.top) + "px";
        if (parseInt(div.style.width) > 85) {
          this.comList.push(div);
          //    console.log(this.comList);
          this.undoStack.push({
            type: "drawDiv",
            BfTar: null,
            AfTar: this.comList[this.comList.length - 1].comNum,
          });
        }
      }
      this.ctx.clearRect(0, 0, 600, 600);
      this.drawLines();
      this.isDrawing = false;
      this.isComDrag = false;
    },
    //lineListの変化に反応して実行
    drawLines: function () {
      // called from moveEnd()
      this.$nextTick(function () {
        this.ctx.clearRect(0, 0, 600, 600);
        //console.log("lines", this.lineList);
        this.lineList.forEach((ele) => {
          switch (ele.class) {
            case "follow":
              var col = "#66f";
            case "extend":
              var col = col ? col : "#f6f";
            case "new":
              var col = col ? col : "#0f0";
          }
          //console.log(this.ctx.strokeStyle);
          this.ctx.strokeStyle = col;
          this.ctx.lineWidth = 5;
          //  console.log(ele);
          const LP = this.nearPosPair(ele);
          //  console.log(LP);
          ArrowCam(
            LP[0],
            LP[2],
            LP[1],
            LP[3],
            [0, 2, -20, 2, -20, 13],
            this.ctx
          );
          if (ele.isfocus == true) {
            this.ctx.setLineDash([2, 2]);
            this.ctx.strokeRect(LP[0], LP[2], LP[1] - LP[0], LP[3] - LP[2]);
            this.ctx.setLineDash([1, 0]);
          }
        });
      });
    },
    nearPosPair: function (ele) {
      // console.log(this.$refs.comCon);
      try {
        const moveTo = KeySearch(
          ele.moveTo.comNum,
          this.$refs.comCon,
          "comNum"
        );
        const moveTo2 = KeySearch(ele.moveTo.cellNum, moveTo.TList, "cellNum");
        const moveToR = moveTo2.Rposi;
        const moveToL = moveTo2.Lposi;
        const lineTo = KeySearch(
          ele.lineTo.comNum,
          this.$refs.comCon,
          "comNum"
        );
        //console.log(lineTo);
        const lineTo2 = KeySearch(ele.lineTo.cellNum, lineTo.TList, "cellNum");

        //      console.log(lineTo2);
        const lineToR = lineTo2.Rposi;
        const lineToL = lineTo2.Lposi;
        //     console.log(moveToR, lineToL, moveToL, lineToR);
        if (Math.abs(moveToR.x - lineToL.x) > Math.abs(moveToL.x - lineToR.x)) {
          return [moveToL.x, lineToR.x, moveToL.y, lineToR.y];
        } else {
          return [moveToR.x, lineToL.x, moveToR.y, lineToL.y];
        }
      } catch (err) {
        console.warn(err);
        //帰属の点がない線を消すと、今度はundoした際に線だけ復元できなくなる
      }
    },
    searchLine: function (e) {
      const posi = new MousePosi(this.AbNode);
      for (let i = 0; i < this.lineList.length; i++) {
        const LP = this.nearPosPair(this.lineList[i]);
        const slope = (LP[2] - LP[3]) / (LP[0] - LP[1]);
        const intercept = -1 * slope * LP[0] + LP[2];
        if (Math.abs(posi.x * slope + intercept - posi.y) < 20) {
          //console.log(LP[0], LP[1], posi.x);
          if (
            (LP[0] < LP[1] && LP[0] < posi.x && LP[1] > posi.x) ||
            (LP[0] >= LP[1] && LP[1] < posi.x && LP[0] > posi.x)
          ) {
            if (this.nowGripedNode.isfocus) this.nowGripedNode.isfocus = false;
            this.nowGripedNode = this.lineList[i];
            this.lineList[i].isfocus = true;
            //            console.log("hit");
          }
        }
      }
    },
    moveComStart: function (e) {
      e.stopPropagation(); //描画機能を作動させない
      const posi = new MousePosi(this.AbNode);
      for (let i = 0; i < this.comList.length; i++) {
        if (
          Math.abs(parseInt(this.comList[i].style.top) - posi.y) < 50 &&
          Math.abs(
            parseInt(this.comList[i].style.left) +
              parseInt(this.comList[i].style.width) / 2 -
              posi.x
          ) < 50
        ) {
          if (this.nowGripedNode.isfocus) this.nowGripedNode.isfocus = false;
          this.nowGripedNode = this.comList[i];
          this.histTmp = JSON.parse(JSON.stringify(this.comList[i]));
          this.isComDrag = true;
        }
      }
    },
    moveCom: function () {
      //   console.log(posi);
      //data値も変えないと再レンダリングで元に戻される
      //nowGripedNodeに保存する方がレンダリングの負荷小
      if (this.isComDrag == true) {
        //  console.log("movexom");
        const posi = new MousePosi(this.AbNode);
        const width = parseInt(this.nowGripedNode.style.width) / 2;
        this.nowGripedNode.style.top = posi.y + 25 + "px";
        this.nowGripedNode.style.left = posi.x - width + "px";
      }
    },
    moveComEnd: function (e) {
      e.stopPropagation();
      const eleNum = e.target.dataset.comnum;
      this.isComDrag = false;
      this.isDrawing = false;
      //まえのようそのプロパティを全部保存しとけば万能
      this.undoStack.push({
        type: "moveDiv",
        BfTar: this.histTmp,
        AfTar: this.nowGripedNode.comNum,
      });
      //      console.log(this.$refs.comCon);
      const ele = KeySearch(eleNum, this.$refs.comCon, "comNum");
      ele.syncPoPosi(eleNum);
      this.drawLines();
    },
    undo: function () {
      if (this.undoStack.length == 0) return;
      //console.log(this.undoStack);
      const undo = this.undoStack.pop();
      console.log(undo);
      switch (undo.type) {
        case "write":
          //console.log(undo, this.$refs.comCon[undo.comNum]);
          this.$refs.comCon[undo.comNum].undo(undo);
          break;
        case "moveDiv":
        case "drawDiv":
          this.redoStack.push({
            type: undo.type,
            BfTar: this.comList[undo.AfTar],
            AfTar: undo.AfTar,
          });
          if (undo.BfTar == undefined) this.comList.splice(undo.AfTar, 1);
          else {
            this.comList.splice(undo.AfTar, 1, undo.BfTar);
            console.log(this.$refs.comCon, undo.AfTar);
            this.$refs.comCon[undo.AfTar].syncPoPosi(undo.AfTar);
          }
          break;
        case "drawLine":
          this.redoStack.push(this.lineList.pop());
          break;
        case "delCom":
          this.comList.splice(undo.AfTar, 0, undo.BfTar[0]);
          this.redoStack.push(undo);
          break;
        case "delLine":
          this.lineList.splice(undo.AfTar, 0, undo.BfTar[0]);
          this.redoStack.push(undo);
          break;
      }
      this.drawLines();
    },
    redo: function () {
      if (this.redoStack.length == 0) return;
      //console.log(this.redoStack, this.redoStack.length, this.redoStack[0]);
      const redo = this.redoStack.pop();
      console.log(redo);
      switch (redo.type) {
        case "write":
          console.log(this.$refs.comCon[redo.comNum]);
          this.$refs.comCon[redo.comNum].redo(redo);
          break;
        case "moveDiv":
        case "drawDiv":
          this.undoStack.push({
            type: redo.type,
            BfTar: this.comList[redo.AfTar],
            AfTar: redo.AfTar,
          });
          this.comList.splice(redo.AfTar, 1, redo.BfTar);
          if ((redo.type = "moveDiv")) {
            // console.log(this.$refs.comCon, redo.AfTar);
            //this.$refs.comCon[redo.AfTar].syncPoPosi(redo.AfTar);
          }
          break;
        case "drawLine":
          this.undoStack.push(redo);
          this.lineList.push(redo);
          console.log(this.lineList);
          break;
        case "delCom":
          this.comList.splice(redo.AfTar, 1);
          this.undoStack.push(redo);
          break;
        case "delLine":
          this.lineList.splice(redo.AfTar, 1);
          this.undoStack.push(redo);
      }
      this.drawLines();
    },
    saveData: function () {
      const fName = prompt("保存するにはファイル名を入力します") + ".json";
      if (fName == "null.json") {
        return 0;
      }
      const sdata = { comList: [], lineList: [], text: [] };
      const link = document.createElement("a");
      sdata.comList = this.comList;
      sdata.lineList = this.lineList;
      for (let i = 0; i < this.$refs.comCon.length; i++) {
        console.log(this.$refs.comCon[i].TList);
        sdata.comList[i].texts = [];
        for (let j = 0; j < this.$refs.comCon[i].TList.length; j++) {
          sdata.comList[i].texts.push({
            text: this.$refs.comCon[i].TList[j].text,
            title: this.$refs.comCon[i].TList[j].title,
          });
        }
      }
      link.download = fName;
      link.href = "data:text/json," + encodeURIComponent(JSON.stringify(sdata));
      link.click();

      /*const xhr = new XMLhttpRequest();
      xhr.open(sdata,"POST");
      xhr.send();*/
      //      console.log(JSON.stringify(sdata));
    },
    keyJudge: function (key, e) {
      //console.log(key);
      switch (key) {
        case 90:
          this.undo();
          break;
        case 89:
          this.redo();
          break;
        case 83:
          e.preventDefault();
          this.saveData(e);
          break;
      }
      return;
    },
  },
};
</script>

<style scoped lang="scss">
canvas {
  border: 2px solid #333;
}
#designField {
  position: relative;
  border: 3px outset #64a;
  top: 0px;
  z-index: 0;
  .cripForCom {
    background-color: #ff6;
    background-image: url("../../img/arrow.png");
    background-size: cover;
    width: 50px;
    height: 50px;
    position: relative;
    top: -50px;
    margin: 0px auto;
    cursor: grab;
    border-radius: 25px;
  }
  .class {
    background-color: #ff6;
    z-index: 2;

    //  @include textInCom();
  }
  .func {
    background-color: #f46;
  }
}
</style>
